import { mutatorAction } from 'satcheljs';
export default mutatorAction('tableExitVirtualSelectAllMode', function tableExitVirtualSelectAllMode(tableView) {
    tableView.isInVirtualSelectAllMode = false;
    tableView.virutalSelectAllExclusionList = [];
    tableView.selectAllModeTimeStamp = null;
});
//# sourceMappingURL=tableExitVirtualSelectAllMode.js.map